<div class="sb-page">
  <header class="sb-header" *ngIf="started && !submitted">
    <button type="button" class="sb-back" (click)="back()" [disabled]="!canGoBack">
      <i class="fa fa-arrow-left" aria-hidden="true"></i>
    </button>
    <div class="sb-title">Scenario‑Based Assessment</div>
  </header>

  <div class="sb-top-progress" *ngIf="started && !submitted">
    <div class="sb-top-progress-inner">
      <div class="sb-rail" aria-hidden="true">
        <span
          class="sb-dot"
          *ngFor="let i of domainSteps"
          [class.sb-dot-active]="i <= domainStepIndex"
        ></span>
        <span class="sb-rail-line"></span>
      </div>
      <div class="sb-progress">{{ progressText }}</div>
    </div>
  </div>

  <main class="sb-main">
    <!-- Already submitted (conflict) -->
    <section class="sb-start" *ngIf="alreadySubmitted">
      <div class="sb-start-card">
        <div class="sb-block">
          <div class="sb-h2">Test already submitted</div>
          <div class="sb-p">{{ alreadySubmittedMessage }}</div>
        </div>
      </div>
    </section>

    <!-- Start page / instruction -->
    <section class="sb-start" *ngIf="!alreadySubmitted && !started && !submitted">
      <div class="sb-start-card">
        <div class="sb-start-head">
          <div class="sb-avatar" aria-hidden="true">
            <img *ngIf="profileImageObjectUrl" [src]="profileImageObjectUrl" alt="" />
          </div>
          <div class="sb-start-meta">
            <div class="sb-prof">{{ staffName }}</div>
            <div class="sb-role">{{ staffPayrollId }}</div>
            <div class="sb-role">{{ staffDesignation }}</div>
            <div class="sb-campus">{{ staffCampus }}</div>
          </div>
        </div>

        <div class="sb-block" *ngIf="loading">
          <div class="sb-p">Loading questions…</div>
        </div>
        <div class="sb-block" *ngIf="!loading && errorMessage">
          <div class="sb-p" style="color: #be123c; font-weight: 800;">{{ errorMessage }}</div>
        </div>

        <div class="sb-block">
          <div class="sb-h2">Assessment Overview</div>
          <div class="sb-p">
            This assessment is designed to evaluate your current leadership practices across academic performance,
            institutional governance, and campus development.
          </div>
        </div>

        <div class="sb-block">
          <div class="sb-h2">Assessment Structure</div>
          <ul class="sb-ul">
            <li>4 Leadership Domains</li>
            <li>5 Questions per domain</li>
            <li>Total: 20 Questions</li>
          </ul>
        </div>

        <div class="sb-block">
          <div class="sb-h2">Time &amp; Completion Guidelines</div>
          <ul class="sb-ul">
            <li>This is a time‑bound assessment.</li>
            <li>Total time: 20 minutes.</li>
            <li>Once time is over, the form will automatically lock.</li>
            <li>Complete the assessment in one sitting.</li>
          </ul>
        </div>

        <div class="sb-block">
          <div class="sb-h2">Before You Begin</div>
          <ul class="sb-ul">
            <li>Sit in a distraction-free environment.</li>
            <li>Allocate uninterrupted time.</li>
            <li>Be prepared for honest self-reflection.</li>
          </ul>
        </div>

        <div class="sb-start-footer">
          <div class="sb-pill">
            <span class="sb-pill-icon" aria-hidden="true"><i class="fa fa-clock-o"></i></span>
            <div class="sb-pill-body">
              <div class="sb-pill-label">Estimated Time</div>
              <div class="sb-pill-value">{{ estimatedTimeLabel }}</div>
            </div>
          </div>
          <div class="sb-pill">
            <span class="sb-pill-icon" aria-hidden="true"><i class="fa fa-question-circle"></i></span>
            <div class="sb-pill-body">
              <div class="sb-pill-label">Total Questions</div>
              <div class="sb-pill-value">{{ totalQuestionsLabel }}</div>
            </div>
          </div>
        </div>
      </div>

      <button type="button" class="sb-primary sb-primary-like-start" (click)="begin()" [disabled]="loading || !!errorMessage || questions.length === 0">
        Begin Assessment
      </button>
    </section>

    <!-- Question page -->
    <section class="sb-qpage" *ngIf="!alreadySubmitted && started && !submitted">
      <div class="sb-domain" *ngIf="currentQuestion as q">
        <div class="sb-domain-title">{{ q.domainKey }}) {{ q.domainTitle }}</div>

        <div class="sb-qtitle">{{ q.no }}. {{ q.title }}</div>

        <div class="sb-situation">{{ q.situation }}</div>

        <div class="sb-label">{{ q.prompt || 'What would you prioritise?' }}</div>
        <div class="sb-options">
          <button
            type="button"
            class="sb-option"
            *ngFor="let o of q.options"
            [class.sb-option-selected]="isSelected(o.id)"
            (click)="select(o.id)"
            [disabled]="completed"
          >
            <span class="sb-option-text">{{ o.sequence ? (o.sequence + ') ') : '' }}{{ o.text }}</span>
            <span class="sb-radio" [class.sb-radio-selected]="isSelected(o.id)"></span>
          </button>
        </div>
      </div>

      <div class="sb-bottom">
        <div class="sb-timer" [class.sb-timer-warn]="remainingSeconds <= 120">{{ timeText }}</div>

        <div class="sb-actions" *ngIf="!completed">
          <button type="button" class="sb-ghost" (click)="back()" [disabled]="!canGoBack">
            <i class="fa fa-undo" aria-hidden="true"></i>
          </button>

          <button
            type="button"
            class="sb-primary sb-primary-like-start"
            *ngIf="showNext"
            (click)="next()"
            [disabled]="!canGoNext"
          >
            Next
          </button>

          <button
            type="button"
            class="sb-primary"
            *ngIf="showSubmit"
            (click)="submit()"
            [disabled]="submitting || !canSubmit"
          >
            {{ submitting ? 'Saving…' : 'Submit' }}
          </button>
        </div>

      </div>
    </section>
  </main>

  <app-assessment-submit-confirm
    [open]="showSubmitConfirm"
    mode="confirm"
    theme="sb"
    (confirmed)="confirmSubmit()"
    (cancelled)="cancelSubmitConfirm()"
  ></app-assessment-submit-confirm>

  <app-assessment-submit-confirm
    [open]="submitted && !alreadySubmitted"
    mode="success"
    theme="sb"
    successMessage="Thank you for submitting your Scenario‑Based Assessment!"
    (dismissed)="confirmationBack()"
  ></app-assessment-submit-confirm>
</div>
